module.exports = __webpack_public_path__ + "static/media/test18_5.f0ac49bb.png";